import {AfterViewInit, Component, HostListener, OnInit, OnDestroy} from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import {InteractionService} from './Shared/Services/interaction.service';
import {PreloaderService} from './Shared/Services/preloader.service';
import { UserService } from './Shared/Services/user.service';
import Swal from 'sweetalert2';
import {CheckInService} from "./Shared/Services/check-in.service";
import {OrderService} from "./Shared/Services/order.service";
import {ReservationService} from "./Shared/Services/reservation.service";
import {DescriptionService} from "./Shared/Services/description.service";
import {Router} from "@angular/router";
import { MenuService } from './Shared/Services/menu.service';
import { HttpClient } from '@angular/common/http';
import { interval, Subscription, of, forkJoin } from 'rxjs';
import { switchMap, catchError, filter, take, tap, map } from 'rxjs/operators';
import { ProductService } from './Shared/Services/product.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls:['./app.component.css']
})

export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'PMS Mercure version 1.O';
  userDetails:any;
  ListHotels:any[] = [];
  d:number = 0;
  private rfidData: string = '';
  k:any=0;
  broadcastChannel: BroadcastChannel;

  private autoCloseCheckInterval: Subscription | null = null;
  private readonly AUTO_CLOSE_DAY = 6;
  private readonly AUTO_CLOSE_HOUR = 0;
  private readonly CHECK_INTERVAL_MS = 3600000;
  private readonly API_URL = 'https://crmapi.valeriahotels.com/api/stock-closings';

  constructor(private interactionService:InteractionService,
              private preloaderService:PreloaderService,
              private keycloakService: KeycloakService,
              private orderService : OrderService,
              private reserChecki:CheckInService,
              private userService: UserService,
              private descriptionservo:DescriptionService,
              private router:Router,
              private menuService: MenuService,
              private http: HttpClient,
              private productService: ProductService) {
               
  }

  private isPublicRoute(): boolean {
    const currentPath = window.location.pathname;
    return currentPath.includes('/pre-checkin') || 
           currentPath.includes('/housemaid/reporting');
  }

  getSortedMenu(menu: any[]) {
    const sortedMenu = menu.sort((a, b) => a.priority - b.priority);
    return sortedMenu.map((menu: { subMenu: any[] }) => {
      if (menu.subMenu && menu.subMenu.length > 0) {
        menu.subMenu = menu.subMenu.sort((a, b) => a.priority - b.priority);
      }
      return menu;
    });
  }
  
  menus : any[] = [];
  rootMenus : any[] = [];
  userMenuStats : any[] = [];
  private userMenuActivationMap: Map<number, boolean> = new Map();

  getUserMenus() {
    const userDetails = localStorage.getItem("userDetails");
    if (!userDetails) {
      console.error("User details not found in localStorage");
      return;
    }
    const userId = JSON.parse(userDetails).userId;

    this.menuService.fetchAllMenus().subscribe(
      (menus) => {
        this.menus = menus.sort((a, b) => a.priority - b.priority);

        this.menuService.fetchUsersActivatedMenus(userId).subscribe(
          (userMenus: any) => {
            this.userMenuStats = userMenus.content?.[0]?.menuStats || [];
            this.userMenuStats.forEach(stat => {
              this.userMenuActivationMap.set(stat.menu.menuId, stat.activated);
            });
            
            this.rootMenus = this.menus
              .filter(menu => menu.isRoot && this.isMenuActivated(menu))
              .sort((a, b) => a.priority - b.priority);

            this.rootMenus.forEach(element => {
              element.subMenu = (element.subMenu || [])
                .filter(sub => this.isMenuActivated(sub))
                .sort((a, b) => a.priority - b.priority);
            });
            
            this.rootMenus.forEach(element => {
              let subMenu = (element.subMenu || [])
                .filter(sub => sub.url == null && sub.isRoot == false && sub.subMenu.length > 0)
              
              if(subMenu.length > 0){
                subMenu.forEach(e => {
                  e.subMenu = (e.subMenu || [])
                    .filter(sub => this.isMenuActivated(sub))
                    .sort((a, b) => a.priority - b.priority);
                });
                element.subMenu = subMenu;
              }
            });

            localStorage.setItem('menus', JSON.stringify(this.rootMenus));
            this.menuService.publishMenus(this.rootMenus);
          },
          (error) => console.error("Error fetching user menus:", error)
        );
      },
      (error) => console.error("Error fetching all menus:", error)
    );
  }

  isMenuActivated(menu: any): boolean {
    return this.userMenuActivationMap.get(menu.menuId) || false;
  }

  // ============================================
  // AUTO-CLOSE STOCK - ALL IN APP
  // ============================================

  private getStockClosings(groupId: number) {
    return this.http.get<any[]>(`${this.API_URL}?groupId=${groupId}`);
  }

  private closeStock(closedBy: string, temporarilyOpened: boolean, groupId: number, closedAt: string, comment: string | null = null) {
    let url = `${this.API_URL}?closedBy=${encodeURIComponent(closedBy)}&temporarilyOpened=${temporarilyOpened}&groupId=${groupId}&closedAt=${closedAt}`;
    if (comment) url += `&comment=${encodeURIComponent(comment)}`;
    return this.http.post<any>(url, {});
  }

  private autoCloseStockWithPosUpdate(groupId: number, closedAt: string) {
    // Étape 1 : Clôturer le stock
    return this.closeStock('Système Automatique', false, groupId, closedAt, 'Fermeture automatique - période dépassée').pipe(
      tap((result: any) => {
        console.log('✅ Stock closing done:', result);
      }),
      // Étape 2 : Mettre à jour les stocks initiaux pour tous les POS
      switchMap((result: any) => {
        console.log(`🔄 Updating initial stocks for all POS, group ${groupId}, date ${closedAt}`);
        return this.productService.getAllPos(groupId).pipe(
          switchMap((posList: any[]) => {
            if (!posList || posList.length === 0) {
              console.log('No POS found');
              return of(result);
            }
            // Appeler l'API pour chaque POS en parallèle
            const updateCalls = posList.map(pos => 
              this.productService.updateInitialStockByRealStock(
                groupId,
                pos.posId,
                closedAt,
                closedAt
              ).pipe(
                tap(() => console.log(`✅ POS ${pos.posId} initial stock updated`)),
                catchError(err => {
                  console.error(`❌ Error updating POS ${pos.posId}:`, err);
                  return of(null);
                })
              )
            );
            return forkJoin(updateCalls).pipe(
              map(() => result),
              catchError(err => {
                console.error('Error in POS updates:', err);
                return of(result);
              })
            );
          }),
          catchError(err => {
            console.error('Error fetching POS list:', err);
            return of(result);
          })
        );
      }),
      catchError(err => {
        console.error('❌ Auto-close error:', err);
        return of(null);
      })
    );
  }

  private shouldAutoClose(): boolean {
    const now = new Date();
    const day = now.getDate();
    const hour = now.getHours();
    return day > this.AUTO_CLOSE_DAY || (day === this.AUTO_CLOSE_DAY && hour >= this.AUTO_CLOSE_HOUR);
  }

  private executeAutoCloseCheck() {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    const prevYear = currentMonth === 0 ? currentYear - 1 : currentYear;
    const lastDay = new Date(prevYear, prevMonth + 1, 0).getDate();
    const closingDate = `${prevYear}-${String(prevMonth + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;

    const userDetails = localStorage.getItem("userDetails");
    if (!userDetails) return of(null);
    const groupId = JSON.parse(userDetails)?.group?.groupId;
    if (!groupId || groupId === 0) return of(null);

    console.log(`🔍 [AUTO-CLOSE] Check month ${prevMonth + 1}/${prevYear} group ${groupId}`);

    return this.getStockClosings(groupId).pipe(
      take(1),
      switchMap((response: any) => {
        const closings = Array.isArray(response) ? response : (response?.content || []);
        console.log('📦 [AUTO-CLOSE] Closings extracted:', closings);

        const isClosed = closings.some((c: any) => {
          const d = new Date(c.closedAt);
          return d.getMonth() === prevMonth && d.getFullYear() === prevYear;
        });

        if (isClosed) {
          console.log(`✅ Month ${prevMonth + 1}/${prevYear} already closed`);
          return of(null);
        }

        console.log(`🔄 Auto-closing month ${prevMonth + 1}/${prevYear}...`);
        return this.autoCloseStockWithPosUpdate(groupId, closingDate);
      }),
      tap((result: any) => {
        if (result) {
          console.log('✅ Auto-close with POS update done:', result);
          Swal.fire({
            title: 'Fermeture Automatique',
            text: `Stock du mois ${prevMonth + 1}/${prevYear} fermé automatiquement.`,
            icon: 'info',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true
          });
        }
      }),
      catchError(err => {
        console.error('❌ Auto-close error:', err);
        return of(null);
      })
    );
  }

  private startAutoCloseScheduler(): void {
    if (!this.shouldAutoClose()) {
      console.log('⏳ Too early for auto-close check');
      return;
    }
    console.log('🚀 Auto-close scheduler starting...');
    this.executeAutoCloseCheck().subscribe();
    this.autoCloseCheckInterval = interval(this.CHECK_INTERVAL_MS).pipe(
      filter(() => this.shouldAutoClose()),
      switchMap(() => this.executeAutoCloseCheck()),
      catchError(err => {
        console.error('Scheduler error:', err);
        return of(null);
      })
    ).subscribe();
  }

  // ============================================
  // END AUTO-CLOSE
  // ============================================

  async ngOnInit(): Promise<void> {
    if (this.isPublicRoute()) {
      console.log('Public route detected - skipping user authentication');
      return;
    }

    const isLoggedIn = await this.keycloakService.isLoggedIn();
    if (!isLoggedIn) {
      console.log('User not logged in');
      return;
    }

    this.keycloakService
      .getKeycloakInstance()
      ?.loadUserInfo()
      .then((res: any) => {
        console.log("user info from Keycloak:", res);
        this.userService.getUserByCode<any>(res.sub).subscribe((data: any) => {
          if (!data) {
            console.error('User not found by Keycloak sub.');
            Swal.fire({ 
              title: 'Access Error', 
              text: 'Your user account is not configured. Please contact your administrator.', 
              icon: 'error' 
            });
            return;
          }
          this.userDetails = data;
          console.log("this.userDetails", this.userDetails);
          localStorage.setItem('userDetails', JSON.stringify(this.userDetails));
          
          if (data.group && data.group.groupId == 0) {
            this.ListHotels = data.preferredGroups;
            this.ListHotels = this.ListHotels.filter(group => group.groupId !== 0);
            console.log("here my List of hotels", this.ListHotels);
            Swal.fire({
              title: 'Please choose your hotel',
              html: this.ListHotels.map(hotel =>
                `<button id="hotel-${hotel.groupId}" class="swal2-confirm swal2-styled">${hotel.name}</button>`
              ).join(''),
              showCancelButton: false,
              showConfirmButton: false,
              preConfirm: () => false,
              didOpen: () => {
                this.ListHotels.forEach(hotel => {
                  const button = document.getElementById(`hotel-${hotel.groupId}`);
                  button.addEventListener('click', () => {
                    this.userDetails.group = hotel;
                    this.userService.updateUser(this.userDetails).toPromise();
                    Swal.close();
                    this.keycloakService
                      .getKeycloakInstance()
                      ?.loadUserInfo()
                      .then((res: any) => {
                        this.userService.getUserByCode<any>(res.sub).subscribe((data: any) => {
                          localStorage.setItem('userDetails', JSON.stringify(data));
                          console.log("user after update and get code", data);
                          this.startAutoCloseScheduler();
                          window.location.reload();
                        });
                      });
                  });
                });
              }
            });
          } else {
            this.startAutoCloseScheduler();
          }
          
          this.getUserMenus();
        });
      });

    this.userService.getDateClosed().subscribe(
      (response: string) => {
         console.log("this.Date ",response );
      },
     (error) => {
        console.error('Error fetching date closed:', error);
      });
  }

  ngAfterViewInit(): void {
    this.preloaderService.hide();
  }

  ngOnDestroy(): void {
    this.autoCloseCheckInterval?.unsubscribe();
  }

  async description(resa: any) {
    console.log("roomId", resa.id);
    try {
      const data = await this.reserChecki.getItembyId(resa.id).toPromise();
      console.log("here my Item", data);
      this.descriptionservo.changedprice = true;
      this.descriptionservo.Item = await data;
      this.descriptionservo.roomIDExist = await  resa.roomId;
      console.log("this.descriptionservo.roomIDExist",this.descriptionservo.roomIDExist);
      this.descriptionservo.NumberOfNeight =await  resa.numberOfNights;
      this.descriptionservo.CheckinDetails =  resa.checkin;
      this.descriptionservo.checkoutDetails = resa.checkout;
      this.descriptionservo.createdDetails = resa.created;
      this.descriptionservo.statusRsea = resa.reservationStatus;
      this.descriptionservo.resa = resa;
      console.log("this.descriptionservo.statusRsea",this.descriptionservo.statusRsea);
      if (this.router.url === '/front-desk/details')
        this.router.navigateByUrl('front-desk/reservationslist');
      else
        this.router.navigateByUrl('front-desk/details');
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  }

  @HostListener('window:keydown', ['$event'])
  async ReadData(event :KeyboardEvent) {
    if(event.key === "Enter") {
      console.log("Données RFID capturées : ", this.rfidData);
      this.reserChecki.getResaByTag(this.rfidData).subscribe({
      next : (resa:any | null) => {
            if (resa) {
              this.description(resa);
              console.log('Reservation:', resa);
            } else {
              console.log('No reservation found for the provided tag.');
            }
        this.rfidData = '';
          },
          error: (err) => {
        console.error('Error fetching reservation:', err);
        this.rfidData = '';
      }})
    } else {
      this.rfidData += event.key;
    }
  }
}